import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
const elements = {
  UILink
};

const Messaging = ({
  langPath,
  source,
  showCta
}) => /*#__PURE__*/_jsxs(UIButtonWrapper, {
  children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: langPath.body,
    elements: elements
  }), showCta ? /*#__PURE__*/_jsx(UIButton, {
    use: "tertiary",
    size: "small",
    "aria-label": text(langPath.cta),
    "data-testid": "suspension-banner-cta-button",
    "data-test-id": "suspension-banner-cta-button",
    href: `/account-verification/${PortalIdParser.get()}?source=${source}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langPath.cta
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {})]
});

export default Messaging;